import {
  Box,
  Button,
  Card,
  CardContent,
  Divider,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { formatDate } from "../../hooks/useFormatDate";
import PdfFullPaymentInvoice from "../../pages/transactions/pdfFullPaymentInvoice";
import PdfPaymentInvoice from "../../pages/transactions/pdfPaymentInvoice";
import DataGridTable from "../DataGridTabel";
import Label from "../label";
import { TxnRefId } from "../miniComponents";
import PdfDownload from "../pdfDownload";
import { copyTextToClipboard } from "../../utils/clipboard";
import { IconButton, Tooltip } from "@mui/material";
import ContentCopyRoundedIcon from "@mui/icons-material/ContentCopyRounded";
import { useSnackbar } from "notistack";


const AllTransactionByListing = ({ tokenName,data, status, noOfFrax, propertyId }) => {

  const [transactionData, setTransactionData] = useState([]);
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const [totalFrax, setTotalFrax] = useState(0)
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  useEffect(() => {

    const tempData = [];
    let tempTotalFrax = 0;
    let runningTotalAmountPaid = 0;
    data.map((e) => {
      // setTotalFrax(prevTotalFrax => prevTotalFrax + Math.round(((e.amountByAdmin || e.status!="REJECTED"&&e.amountTransferred) / e?.rpf).toFixed()) || 0);

      let currentPaymentFrax = 0;
      if (e.status === "APPROVED" || e.status === "PAID") currentPaymentFrax = ((e.amountByAdmin || e.amountTransferred) / e.rpf);
      tempTotalFrax += currentPaymentFrax;

      const amountPaid = e.amountByAdmin || 0;
      runningTotalAmountPaid += amountPaid;

      tempData.push({
        _id: e.paymentNo,
        rpf: `₹ ${(e?.rpf || e?.amount / noOfFrax)?.toFixed(2)}`,
        amountByAdmin: e.amountByAdmin || 0,
        amountTransferred: e.amountTransferred || 0,
        // frax: currentPaymentFrax,
        updated_at: e?.dateoftrans ? moment.unix(e?.dateoftrans).format("DD/MM/YYYY") : "-",
        actionTaken: e?.adminActionTakenOn ? formatDate(e?.adminActionTakenOn).format("DD/MM/YYYY") : "-",
        listingId: e.listingId,
        refId: e?.chequeno || e.walletTransactionId,
        transactionId: e?.transactionId,
        status: e?.status,
        adminActionTakenOn: e?.adminActionTakenOn,
        totalAmountPaid: runningTotalAmountPaid,
        amount: e?.amount,
        propertyCode: e?.propertyCode,
        propertyName: e?.propertyName,
        investorName:e.investorName,
        isRefunded:e.isRefunded,
        refundMode:e.refundMode,
        paymentMode:e.paymentMode
      });
    });
    setTotalFrax(Math.floor(tempTotalFrax));
    setTransactionData(tempData)
  }, []);
  
  const hasApprovedStatus = Array.isArray(transactionData) && transactionData.some(row => row.status === 'APPROVED' || (row.status==="REFUNDED" && row.isRefunded));

  const getStatusLabel = (row) =>
    row?.status === "REFUNDED" && !row?.adminActionTakenOn && row?.refundMode !== "WALLET" ? "Refund Pending" : row?.status;

  const getStatusColor = (row) => {
    console.log(row,"row");
    if (row?.status === "PAID") return "warning";
    if (row?.status === "REJECTED") return "error";
    if (row?.status === "APPROVED") return "success";
    if (row?.status === "REFUNDED" && !row?.adminActionTakenOn) return "warning";
    return "default";
  };

  const paymentMode = {
    "WALLET": "Wallet",
    "BANK_TRANSFER": "Bank Transfer",
    "PAYMENT_GATEWAY": "Payment Gateway",
    "UPI": "UPI"
  }

  const statusCell = (row) =>
    row?.status ? (
      <Label sx={{ px: 1.5, py: 0.5, fontWeight: 600, whiteSpace: "nowrap" }} variant="ghost" color={getStatusColor(row)}>
        {getStatusLabel(row)}
      </Label>
    ) : (
      "-"
    );

  const transactionGridSx = {
    minWidth: hasApprovedStatus ? 1180 : 1040,
    "& .MuiDataGrid-cell": {
      overflow: "visible",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    "& .MuiDataGrid-cellContent": {
      overflow: "visible",
    },
  };

  const table = [
    {
      field: "_id",
      headerName: "Payment No",
      minWidth: 110,
      flex: 0.9,
    },
    {
      field: "paymentMode",
      headerName: "Payment Mode",
      minWidth: 110,
      flex: 0.9,
      renderCell: (params) => (
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", width: "100%", overflow: "visible" }}>
          {paymentMode[params.row.paymentMode]}
        </Box>
      ),
    },
    {
      field: "amountTransferred",
      headerName: "Amount Transferred",
      minWidth: 150,
      flex: 1,
      valueFormatter: (params) => `₹${params?.toLocaleString("en-IN")}` || 0,
    },
    {
      field: "amountByAdmin",
      headerName: "Accepted Amount",
      minWidth: 140,
      flex: 1,
      valueFormatter: (params) => `₹${params?.toLocaleString("en-IN")}` || 0,
    },
    {
      field: "refId",
      headerName: "Reference ID",
      minWidth: 130,
      flex: 1,
      renderCell: (params) => (
        <>
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%", height: "100%" }}>
          {params.row.refId == null ? "-" : <TxnRefId elemProps={params.row.refId} />}
        </Box>
        <Tooltip title="Copy Transaction ID" placement="top">
          <IconButton
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              copyTextToClipboard(params.row.refId);
              enqueueSnackbar("Reference ID copied to clipboard", { variant: "success" });
            }}
            sx={{ flexShrink: 0 }}
          >
            <ContentCopyRoundedIcon sx={{ fontSize: 16 }} />
          </IconButton>
        </Tooltip>
        </>
      ),
    },
    { field: "rpf", headerName: `Rate/${tokenName || "FRAX"}`, minWidth: 110, flex: 0.8 },
    { field: "updated_at", headerName: "Payment Date", minWidth: 120, flex: 0.9 },
    { field: "actionTaken", headerName: "Action Date", minWidth: 120, flex: 0.9 },
    {
      field: "status",
      headerName: "Status",
      minWidth: 160,
      flex: 0,
      sortable: false,
      renderCell: (params) => (
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", width: "100%", overflow: "visible" }}>
          {statusCell(params.row)}
        </Box>
      ),
    },
    ...(hasApprovedStatus
      ? [
          {
            field: "Invoice",
            headerName: "Receipt",
            minWidth: 130,
            flex: 0,
            sortable: false,
            renderCell: (params) => {
              const { status, isRefunded } = params.row;
              const shouldRenderPdf = (status === "REFUNDED" && isRefunded) || status === "APPROVED";
              return (
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", width: "100%" }}>
                  {shouldRenderPdf ? (
                    <PdfDownload
                      contentComponent={
                        <PdfPaymentInvoice data={params.row} refunded={status === "REFUNDED" && isRefunded} />
                      }
                      filename="PaymentReceipt.pdf"
                    />
                  ) : null}
                </Box>
              );
            },
          },
        ]
      : []),
  ];
  let refundInitated=!transactionData?.some(data => data.status === "REFUNDED"&& !data?.adminActionTakenOn)
  return (
    <Box >
      <Stack
        direction={{ xs: "column", sm: "row" }}
        spacing={1.5}
        alignItems={{ xs: "flex-start", md: "center" }}
        justifyContent="space-between"
        sx={{ width: "100%", mb: 1 }}
      >
        <Stack direction="row" spacing={1} flexWrap="wrap">
          <Typography sx={{ fontWeight: 500 }}>
            {(status !== "FRAXTRANSFERED" && status !== "APPROVED")
              ? `Allocated ${tokenName || "FRAX"}`
              : `Total ${tokenName || "FRAX"}`}{" "}
            :
          </Typography>
          <Typography>
            {["REFUNDED", "REJECTED", "EXPIRED"].includes(status) ? 0 : noOfFrax}
          </Typography>
        </Stack>

        {(status !== "FRAXTRANSFERED" && status !== "APPROVED") && (
          <Stack direction="row" spacing={1}>
            <Typography sx={{ fontWeight: 500 }}>
              {`${tokenName || "FRAX"}`} Owned :
            </Typography>
            <Typography>{status === "REFUNDED" ? 0 : totalFrax}</Typography>
          </Stack>
        )}

    <Stack sx={{width:{xs:"100%",sm:"auto"}}} direction={{xs:"column",sm:"row"}} spacing={1}>
          {((status === "APPROVED" || status === "FRAXTRANSFERED" || status === "REFUNDED") && refundInitated) && (
            <PdfDownload
              contentComponent={
                <PdfFullPaymentInvoice
                  data={transactionData}
                  refunded={status === "REFUNDED"}
                  refundeAmount={
                    status === "REFUNDED"
                      ? transactionData?.filter(txn => txn.status === "REFUNDED")?.reduce((sum, txn) => sum + (txn.amountTransferred || 0), 0)
                      : transactionData?.[transactionData.length - 1]?.totalAmountPaid
                  }
                />
              }
              filename="FullPaymentReceipt.pdf"
              buttonText="Full Payment Receipt"
            />
          )}

          <Button
            size="small"
            variant="outlined"
            onClick={() => navigate(`/dashboard/property/${propertyId}`, { state: { id: propertyId } })}
            sx={{ padding: "10px" }}
          >
            Show asset details
          </Button>
        </Stack>
      </Stack>

      {isMobile ? (
        <Stack spacing={2} sx={{ pb: 2, mx: "auto", maxWidth: 560, overflowY: "auto", }}>
          {transactionData.map((row) => (
            <Card
              key={row._id}
              sx={{
                boxShadow: { xs: 4, sm: 2 },
                borderRadius: { xs: 3, sm: 2 },
                border: "1px solid",
                borderColor: "divider",
              }}
            >
              <CardContent>
                <Stack direction="row" justifyContent="space-between" spacing={2}>
                  <Typography variant="label">Payment No</Typography>
                  <Typography variant="body2" sx={{ textAlign: "right" }}>
                    {row._id}
                  </Typography>
                </Stack>
                <Divider sx={{ my: 1.25 }} />

                <Stack spacing={1}>
                  <Stack direction="row" justifyContent="space-between" spacing={2}>
                    <Typography variant="label">Amount Transferred</Typography>
                    <Typography variant="body2" sx={{ textAlign: "right" }}>
                      ₹{(row.amountTransferred || 0).toLocaleString("en-IN")}
                    </Typography>
                  </Stack>
                  <Stack direction="row" justifyContent="space-between" spacing={2}>
                    <Typography variant="label">Accepted Amount</Typography>
                    <Typography variant="body2" sx={{ textAlign: "right" }}>
                      ₹{(row.amountByAdmin || 0).toLocaleString("en-IN")}
                    </Typography>
                  </Stack>
                  <Stack direction="row" justifyContent="space-between" spacing={2}>
                    <Typography variant="label">Reference ID</Typography>
                    <Box sx={{ textAlign: "right" }}>
                      {row.refId === null || row.refId === undefined ? "-" : <TxnRefId elemProps={row.refId} />}
                    </Box>
                  </Stack>
                  <Stack direction="row" justifyContent="space-between" spacing={2}>
                    <Typography variant="label">Rate/{tokenName || "FRAX"}</Typography>
                    <Typography variant="body2" sx={{ textAlign: "right" }}>
                      {row.rpf}
                    </Typography>
                  </Stack>
                  <Stack direction="row" justifyContent="space-between" spacing={2}>
                    <Typography variant="label">Payment Date</Typography>
                    <Typography variant="body2" sx={{ textAlign: "right" }}>
                      {row.updated_at}
                    </Typography>
                  </Stack>
                  <Stack direction="row" justifyContent="space-between" spacing={2}>
                    <Typography variant="label">Action Date</Typography>
                    <Typography variant="body2" sx={{ textAlign: "right" }}>
                      {row.actionTaken}
                    </Typography>
                  </Stack>
                  <Stack direction="row" justifyContent="space-between" spacing={2} alignItems="center">
                    <Typography variant="label">Status</Typography>
                    {statusCell(row)}
                  </Stack>
                </Stack>

                {(() => {
                  const shouldRenderPdf =
                    (row.status === "REFUNDED" && row.isRefunded) || row.status === "APPROVED";
                  return shouldRenderPdf ? (
                    <Box mt={2}>
                      <PdfDownload
                        contentComponent={
                          <PdfPaymentInvoice
                            data={row}
                            refunded={row.status === "REFUNDED" && row.isRefunded}
                          />
                        }
                        filename="PaymentReceipt.pdf"
                      />
                    </Box>
                  ) : null;
                })()}
              </CardContent>
            </Card>
          ))}
        </Stack>
      ) : (
        <Box sx={{ width: "100%", overflowX: "auto" }}>
          <DataGridTable
            initialColumns={table}
            initialRows={transactionData}
            initialRowHeight={56}
            sx={transactionGridSx}
          />
        </Box>
      )}
    </Box>
  )

};

export default AllTransactionByListing;